import { render, staticRenderFns } from "./BlogSidebar.vue?vue&type=template&id=12c9a29e&scoped=true"
import script from "./BlogSidebar.vue?vue&type=script&lang=js"
export * from "./BlogSidebar.vue?vue&type=script&lang=js"
import style0 from "./BlogSidebar.vue?vue&type=style&index=0&id=12c9a29e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c9a29e",
  null
  
)

export default component.exports